import React from 'react';
import { NavLink } from 'react-router-dom';
import { Translate, withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { isNullOrUndefined } from '../../store/storeFunctions';
import classnames from 'classnames';
import MainHeader from './mainHeader';
import { parseQuery } from '../../store/apiWrapper';

class SearchResultsHeader extends React.Component {
    render() {
        const title = this.props.translate('LeftPanel.Unicorn');
        const editReqConfig = this.editingRequest('configuration');
        const editReqSearch = this.editingRequest('parameters');

        return (<>
            <MainHeader raw={`${title}${editReqConfig ? ` - ${editReqConfig}` : editReqSearch ? ` - ${editReqSearch}` : ""}`} {...this.props} />
            { !this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', {'tinted' :this.props.tinted })}>
                <ul style={{ border: "none" }}>
                    <li className={classnames('tab-link', {"is-active": this.isActiveLink('parameters')})}>
                        <NavLink to={`${this.props.match.url}/parameters`}>
                            <Translate id='Search.Common.SubjectSearch' />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: this.isActiveLink('parameters') ? "" : "none" }}></div>
                    </li>
                    {this.isActiveLink('configuration') && <li className='tab-link is-active'>
                        <a style={{pointerEvents:'none'}}><Translate id='MarketingList.Configuration' /></a>
                        <div className="search-progress-short"></div>
                    </li>}
                    <li className={classnames('tab-link', {"is-active": this.isActiveLink('templates')})}>
                        <NavLink to={`${this.props.match.url}/templates`}>
                            <Translate id='MarketingList.Templates' />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: this.isActiveLink('templates') ? "" : "none" }}></div>
                    </li>
                    <li className={classnames('tab-link', {'is-active':this.isActiveLink('results') || this.isActiveLink('file')})}>
                        <NavLink to={`${this.props.match.url}/results`}>
                            <Translate id='MarketingList.Results' />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: this.isActiveLink('results') || this.isActiveLink('file') ? "" : "none" }}></div>
                    </li>
                </ul>
            </div> }
        </>)
    }

    editingRequest(item) {
        const cond = this.props.location.pathname.indexOf(item) >= 0;
        if (!cond)
            return null;

        const qs = parseQuery(this.props.location.search);
        if (!isNullOrUndefined(qs.requestId)) {
            const ident = `${this.props.translate('MarketingList.Common.Shortening')}${qs.requestId}`;
            if (item === 'configuration')
                return `${this.props.translate('MarketingList.Header.EditingConfig')} ${ident}`;
            if (item === 'parameters')
                return `${this.props.translate('MarketingList.Header.EditingSearch')} ${ident}`;
        }

        return null;
    }

    isActiveLink(item) {
        return this.props.location.pathname.indexOf(item) >= 0;
    }
}

export default withLocalize(withRouter(SearchResultsHeader));